import React, { Component, Fragment } from 'react';
import { Tabs, Tab, Divider } from '@material-ui/core';
import EditWidgetTab from './EditWidgetTab';
export class EditWidget extends Component {
  constructor (props) {
    super(props);
    this.state = { value: 0 };
  }

    handleChange = (event, value) => {
      this.setState({ value });
    };
    render () {
      const { value } = this.state;
      return (
        <Fragment>
          <Tabs
            fullWidth
            centered
            value={value}
            indicatorColor='primary'
            onChange={this.handleChange}
          >
            <Tab label='Update Widget Info' style={{ fontWeight: 'bold' }} />
          </Tabs>
          <Divider />
          {value === 0 && <EditWidgetTab {...this.props} />}
        </Fragment>
      );
    }
}

export default EditWidget;
